module.exports = __webpack_public_path__ + "static/q5answer4_trailmix_wishmas-ea39290e221ab69929f58137656457aa.jpg";